import React, { FunctionComponent, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { StyledContainer } from "./styles";

import { configState, setIframeLayer, setLoader } from "state/config-slice";
import { fetchCreditCards } from "state/credit-cards-slice";
import { setNeedsRefetching } from "state/offers-slice";

const IframeLayer: FunctionComponent = () => {
  const {
    IframeLayer: { showIframeLayer, url },
  } = useSelector(configState);

  const dispatch = useDispatch();

  useEffect(() => {
    const handleClosingIframe = async (event: MessageEvent) => {
      if (event.data === "closeIframe" && event.origin === window.location.origin) {
        dispatch(setLoader({ showLoader: true, messageHeader: "", messageText: "" }));
        dispatch(setNeedsRefetching(true));
        await dispatch(fetchCreditCards());
        dispatch(
          setLoader({
            showLoader: false,
          }),
        );

        dispatch(setIframeLayer({ showIframeLayer: false, url: null }));
      }
    };

    window.addEventListener("message", handleClosingIframe);

    return () => {
      window.removeEventListener("message", handleClosingIframe);
    };
  }, [dispatch]);

  return (
    <StyledContainer $isVisible={showIframeLayer}>
      <iframe
        src={url ? url : ""}
        title="papa-iframe"
        name="papa-iframe"
        id="papaIframe"
        style={{ height: "100%", width: "100%" }}
      ></iframe>
    </StyledContainer>
  );
};

export default React.memo(IframeLayer);
